import React from "react";

import { SideNavigation } from "@ui5/webcomponents-react/lib/SideNavigation";
import { SideNavigationListItem } from "@ui5/webcomponents-react/lib/SideNavigationListItem";
import { SideNavigationOpenState } from "@ui5/webcomponents-react/lib/SideNavigationOpenState";

import "@ui5/webcomponents-icons/dist/icons/compare.js";
import "@ui5/webcomponents-icons/dist/icons/home.js";
import "@ui5/webcomponents-icons/dist/icons/employee.js";
import "@ui5/webcomponents-icons/dist/icons/lead.js";
import "@ui5/webcomponents-icons/dist/icons/add-product.js";
import "@ui5/webcomponents-icons/dist/icons/approvals.js";
import "@ui5/webcomponents-icons/dist/icons/chain-link.js";

import "./SideDrawer.css";

const SideDrawer = (props) => {

  const onItemClick = (e) => {
    props.sideBarRedirection(e.parameters.selectedId);
    props.closeDrawer();
  };

  const getOpenState = () => {
    if (props.isDrawerOpen) {
      return SideNavigationOpenState.Expanded;
    }
    if (!props.isDrawerOpen && window.screen.width > 768) {
      return SideNavigationOpenState.Condensed;
    }
    if (!props.isDrawerOpen && window.screen.width < 768) {
      return SideNavigationOpenState.Collapsed;
    }
  };

  return (
    <SideNavigation
      openState={getOpenState()}
      selectedId={"sales-leads"}
      onItemClick={onItemClick}
      noIcons={false}
      style={{ height: "900px" }}
    >
      <SideNavigationListItem
        text="Home Page"
        icon="home"
        id="home"
        tooltip="Nav To Home"
      />
      <SideNavigationListItem text="Payment Recommendation Approval" icon="approvals" id="approvals" />
    </SideNavigation>
  );
};

export default SideDrawer;
